<template>
    <div>
        <v-stripe-card v-model="source" api-key="pk_live_gLhZiUgcJkSNOaqVY4vsDt1700w2gMlbft"></v-stripe-card>
        <v-btn @click="test"> TEST </v-btn>
    </div>
</template>

<script>
    import {functions} from "@/firebase/firebase"

    export default {
        name: 'account-setup',
        data: () => ({
            source: ''
        }),
        async created(){

        },
        methods: {
            async test(){
                const createCheckoutSession = functions.httpsCallable("createCheckoutSession")
                const result = await createCheckoutSession()
                console.log( result )

                if( result && result.data && result.data.id ){
                    const stripe = Stripe('pk_live_gLhZiUgcJkSNOaqVY4vsDt1700w2gMlbft')

                    const {error} = await stripe.redirectToCheckout({
                        // Make the id field from the Checkout Session creation API response
                        // available to this file, so you can provide it as parameter here
                        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                        sessionId: result.data.id
                    })
                }

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>